module.exports = __WEBPACK_EXTERNAL_MODULE_45__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"element-ui","commonjs2":"element-ui","amd":"element-ui","root":"ElementUI"}
// module id = 45
// module chunks = 0